module.exports = __webpack_public_path__ + "img/154.0df41f47.jpg";